import MotionHoc from "./MotionHoc";
import ocrDetectorWrapper from "../components/ocrDetector/ocrDetectorWrapper";

const OcrPage = MotionHoc(ocrDetectorWrapper);

export default OcrPage;
